export enum CashboxErrorOrigin {
    GET_CASHBOX_CATEGORIES = 'GET_CASHBOX_CATEGORIES',
    UPSERT_CASHBOX_CATEGORY = 'UPSERT_CASHBOX_CATEGORY',
    CREATE_INCOME_RECORD = 'CREATE_INCOME_RECORD',
    GET_INCOME_RECORDS = 'GET_INCOME_RECORDS',
}

export interface CashboxError {
    type: CashboxErrorOrigin,
    detail: any
}